import { IDashboardMetadata } from '../dashboard-metadata.service';
import { TestDashboardFiltersComponent } from '../filters/test/test-dashboard-filters.component';

export const TEST_DASHBOARD_CONFIG:IDashboardMetadata = {
  title: 'Test KPI',
  filterComponent: {
    name: TestDashboardFiltersComponent
  },
  mapping: {
    Row_num: 'numberOfRows'
  },
  reports: [
    {
      id: 500,
      key: 'REPORT_500_1'
    },
    {
      id: 500,
      key: 'REPORT_500_2'
    },
    {
      id: 500,
      key: 'REPORT_500_3'
    },
    {
      id: 500,
      key: 'REPORT_500_4'
    },
    {
      id: 500,
      key: 'REPORT_500_5'
    },
    {
      id: 500,
      key: 'REPORT_500_6'
    },
    {
      id: 500,
      key: 'REPORT_500_7'
    },
    {
      id: 500,
      key: 'REPORT_500_8'
    },
    {
      id: 500,
      key: 'REPORT_500_9'
    },
    {
      id: 500,
      key: 'REPORT_500_10'
    }
  ]
};